import { Flex, Text, Link as ChakraLink, Button } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
// import useTranslation from "next-translate/useTranslation";
import Link from 'next/link';
import { snakeCase } from 'lodash';
import { configFile } from '@/config';
import { handleGTMClick } from '@/helpers/handleGTMClick';

export default function AuthorCardHorizontal({ post }: any) {
  const { t } = useTranslation('common');

  return (
    <Flex
      maxWidth="1216px"
      m="80px auto"
      width="90%"
      textAlign="center"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
      borderRadius="8px"
      overflow="hidden"
      bgColor={configFile.tertiaryAccentColor}
      padding="56px"
    >
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        gap="48px"
        m="0 auto"
        direction={{ base: 'column', md: 'row' }}
      >
        <Flex
          direction="column"
          gap="16px"
          flexGrow="1"
          minWidth="122px"
          w={{ base: '100%', md: 'auto' }}
          alignItems="center"
        >
          <Image
            width="122"
            height="122"
            style={{
              borderRadius: '10px',
              objectFit: 'cover',
              width: '122px',
              height: '122px',
            }}
            alt={post.data[0].attributes.author.data.attributes.name}
            src={post.data[0].attributes.author.data.attributes.img.data.attributes.url}
          />
          <Button
            aria-label="perfil page"
            width="100%"
            bgColor={configFile.secondaryAccentColor}
            color={configFile.tertiaryAccentColor}
            _hover={{ bgColor: configFile.sixAccentColor }}
          >
            <ChakraLink
              id={`blog_author_${snakeCase(post.data[0].attributes.author.data.attributes.name)}`}
              onClick={handleGTMClick}
              onAuxClick={handleGTMClick}
              as={Link}
              href={`perfil/${post.data[0].attributes.author.data.attributes.url}`}
            >
              {t('article.author.button')}
            </ChakraLink>
          </Button>
        </Flex>
        <Flex width="100%" direction="column" flexGrow="2" maxW="704px" alignItems="flex-start" h="100%">
          <Text fontWeight="700" color="gray.800" fontSize="16px" lineHeight="24px">
            {post.data[0].attributes.author.data.attributes.name}
          </Text>
          <Text fontSize="14px" color="gray.600" lineHeight="20px" fontWeight="400" mt="4px" mb="24px">
            {post.data[0].attributes.author.data.attributes.jobTitle}
          </Text>

          <Text fontWeight={400} color="gray.600" textAlign="start" lineHeight="20px" fontSize="14px">
            {post.data[0].attributes.author.data.attributes.description}
          </Text>
        </Flex>
        <Flex
          direction="column"
          gap="24px"
          flexGrow="1"
          alignItems="flex-start"
          h="100%"
          minW="128px"
          w={{ base: '100%', md: 'auto' }}
        >
          <Text fontWeight="700" color="gray.800" fontSize="16px" lineHeight="24px">
            {t('article.author.socialMedia')}
          </Text>

          <Flex direction="column" alignItems="flex-start" gap="12px">
            {post.data[0].attributes.author.data.attributes.instagram !== null && (
              <ChakraLink
                id={`blog_instagram_${snakeCase(post.data[0].attributes.author.data.attributes.name)}`}
                onClick={handleGTMClick}
                onAuxClick={handleGTMClick}
                as={Link}
                target="_blank"
                rel="noopener noreferrer"
                width="24px"
                height="24px"
                borderRadius="100%"
                display="flex"
                justifyContent="center"
                bgColor="gray.100"
                alignItems="center"
                _hover={{ bgColor: configFile.primaryAccentColor }}
                href={post.data[0].attributes.author.data.attributes.instagram}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5 0C13.217 0 13.556 0.00999994 14.622 0.0599999C15.687 0.11 16.412 0.277 17.05 0.525C17.71 0.779 18.266 1.123 18.822 1.678C19.3305 2.1779 19.724 2.78259 19.975 3.45C20.222 4.087 20.39 4.813 20.44 5.878C20.487 6.944 20.5 7.283 20.5 10C20.5 12.717 20.49 13.056 20.44 14.122C20.39 15.187 20.222 15.912 19.975 16.55C19.7247 17.2178 19.3311 17.8226 18.822 18.322C18.322 18.8303 17.7173 19.2238 17.05 19.475C16.413 19.722 15.687 19.89 14.622 19.94C13.556 19.987 13.217 20 10.5 20C7.783 20 7.444 19.99 6.378 19.94C5.313 19.89 4.588 19.722 3.95 19.475C3.28233 19.2245 2.67753 18.8309 2.178 18.322C1.66941 17.8222 1.27593 17.2175 1.025 16.55C0.777 15.913 0.61 15.187 0.56 14.122C0.513 13.056 0.5 12.717 0.5 10C0.5 7.283 0.51 6.944 0.56 5.878C0.61 4.812 0.777 4.088 1.025 3.45C1.27524 2.78218 1.6688 2.17732 2.178 1.678C2.67767 1.16923 3.28243 0.775729 3.95 0.525C4.588 0.277 5.312 0.11 6.378 0.0599999C7.444 0.0129999 7.783 0 10.5 0ZM10.5 5C9.17392 5 7.90215 5.52678 6.96447 6.46447C6.02678 7.40215 5.5 8.67392 5.5 10C5.5 11.3261 6.02678 12.5979 6.96447 13.5355C7.90215 14.4732 9.17392 15 10.5 15C11.8261 15 13.0979 14.4732 14.0355 13.5355C14.9732 12.5979 15.5 11.3261 15.5 10C15.5 8.67392 14.9732 7.40215 14.0355 6.46447C13.0979 5.52678 11.8261 5 10.5 5ZM17 4.75C17 4.41848 16.8683 4.10054 16.6339 3.86612C16.3995 3.6317 16.0815 3.5 15.75 3.5C15.4185 3.5 15.1005 3.6317 14.8661 3.86612C14.6317 4.10054 14.5 4.41848 14.5 4.75C14.5 5.08152 14.6317 5.39946 14.8661 5.63388C15.1005 5.8683 15.4185 6 15.75 6C16.0815 6 16.3995 5.8683 16.6339 5.63388C16.8683 5.39946 17 5.08152 17 4.75ZM10.5 7C11.2956 7 12.0587 7.31607 12.6213 7.87868C13.1839 8.44129 13.5 9.20435 13.5 10C13.5 10.7956 13.1839 11.5587 12.6213 12.1213C12.0587 12.6839 11.2956 13 10.5 13C9.70435 13 8.94129 12.6839 8.37868 12.1213C7.81607 11.5587 7.5 10.7956 7.5 10C7.5 9.20435 7.81607 8.44129 8.37868 7.87868C8.94129 7.31607 9.70435 7 10.5 7Z"
                    fill="#2D3748"
                  />
                </svg>
              </ChakraLink>
            )}
            {post.data[0].attributes.author.data.attributes.twitter !== null && (
              <ChakraLink
                id={`blog_twitter_${snakeCase(post.data[0].attributes.author.data.attributes.name)}`}
                onClick={handleGTMClick}
                onAuxClick={handleGTMClick}
                target="_blank"
                rel="noopener noreferrer"
                width="20px"
                height="20px"
                borderRadius="100%"
                display="flex"
                bgColor="gray.100"
                justifyContent="center"
                alignItems="center"
                _hover={{ bgColor: configFile.primaryAccentColor }}
                as={Link}
                href={post.data[0].attributes.author.data.attributes.twitter}
              >
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.1621 2.65593C20.3986 2.99362 19.589 3.2154 18.7601 3.31393C19.6338 2.79136 20.2878 1.96894 20.6001 0.999927C19.7801 1.48793 18.8811 1.82993 17.9441 2.01493C17.3147 1.34151 16.4804 0.89489 15.571 0.744511C14.6616 0.594133 13.728 0.748418 12.9153 1.18338C12.1026 1.61834 11.4564 2.30961 11.0772 3.14972C10.6979 3.98983 10.6068 4.93171 10.8181 5.82893C9.15516 5.74558 7.52838 5.31345 6.04334 4.56059C4.55829 3.80773 3.24818 2.75097 2.19805 1.45893C1.82634 2.09738 1.63101 2.82315 1.63205 3.56193C1.63205 5.01193 2.37005 6.29293 3.49205 7.04293C2.82806 7.02202 2.17869 6.84271 1.59805 6.51993V6.57193C1.59825 7.53763 1.93242 8.47354 2.5439 9.22099C3.15538 9.96843 4.00653 10.4814 4.95305 10.6729C4.33667 10.84 3.69036 10.8646 3.06305 10.7449C3.32992 11.5762 3.85006 12.3031 4.55064 12.824C5.25123 13.3449 6.09718 13.6337 6.97005 13.6499C6.10253 14.3313 5.10923 14.8349 4.04693 15.1321C2.98464 15.4293 1.87418 15.5142 0.779053 15.3819C2.69075 16.6114 4.91615 17.264 7.18905 17.2619C14.8821 17.2619 19.0891 10.8889 19.0891 5.36193C19.0891 5.18193 19.0841 4.99993 19.0761 4.82193C19.8949 4.23009 20.6017 3.49695 21.1631 2.65693L21.1621 2.65593Z"
                    fill="#2D3748"
                  />
                </svg>
              </ChakraLink>
            )}
            {post.data[0].attributes.author.data.attributes.linkedin !== null && (
              <ChakraLink
                id={`blog_linkedin_${snakeCase(post.data[0].attributes.author.data.attributes.name)}`}
                onClick={handleGTMClick}
                onAuxClick={handleGTMClick}
                target="_blank"
                rel="noopener noreferrer"
                height="28px"
                display="flex"
                alignItems="center"
                _hover={{ fontStyle: 'none' }}
                as={Link}
                gap="4px"
                href={post.data[0].attributes.author.data.attributes.linkedin}
              >
                <svg width="16" height="16" viewBox="0 5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 8.219v15.563c0 1.469 1.156 2.625 2.625 2.625h15.563c0.719 0 1.406-0.344 1.844-0.781 0.469-0.469 0.781-1.063 0.781-1.844v-15.563c0-1.469-1.156-2.625-2.625-2.625h-15.563c-0.781 0-1.375 0.313-1.844 0.781-0.438 0.438-0.781 1.125-0.781 1.844zM2.813 10.281c0-1 0.813-1.875 1.813-1.875 1.031 0 1.875 0.875 1.875 1.875 0 1.031-0.844 1.844-1.875 1.844-1 0-1.813-0.813-1.813-1.844zM7.844 23.125v-9.531c0-0.219 0.219-0.406 0.375-0.406h2.656c0.375 0 0.375 0.438 0.375 0.719 0.75-0.75 1.719-0.938 2.719-0.938 2.438 0 4 1.156 4 3.719v6.438c0 0.219-0.188 0.406-0.375 0.406h-2.75c-0.219 0-0.375-0.219-0.375-0.406v-5.813c0-0.969-0.281-1.5-1.375-1.5-1.375 0-1.719 0.906-1.719 2.125v5.188c0 0.219-0.219 0.406-0.438 0.406h-2.719c-0.156 0-0.375-0.219-0.375-0.406zM2.875 23.125v-9.531c0-0.219 0.219-0.406 0.375-0.406h2.719c0.25 0 0.406 0.156 0.406 0.406v9.531c0 0.219-0.188 0.406-0.406 0.406h-2.719c-0.188 0-0.375-0.219-0.375-0.406z"
                    fill="#0A66C2"
                  />
                </svg>
                <Text fontWeight={400} color="gray.600" textAlign="start" lineHeight="20px" fontSize="14px">
                  LinkedIn
                </Text>
              </ChakraLink>
            )}
            {post.data[0].attributes.author.data.attributes.website !== null && (
              <ChakraLink
                id={`blog_website_${snakeCase(post.data[0].attributes.author.data.attributes.name)}`}
                onClick={handleGTMClick}
                onAuxClick={handleGTMClick}
                target="_blank"
                rel="noopener noreferrer"
                height="28px"
                display="flex"
                alignItems="center"
                _hover={{ fontStyle: 'none' }}
                as={Link}
                gap="4px"
                href={post.data[0].attributes.author.data.attributes.website}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11 8C11 8.71875 10.9375 9.375 10.875 10H5.09375C5.03125 9.375 4.96875 8.71875 4.96875 8C4.96875 7.3125 5.03125 6.65625 5.09375 6H10.875C10.9375 6.65625 11 7.3125 11 8ZM15.7188 6C15.9062 6.65625 16 7.3125 16 8C16 8.71875 15.9062 9.375 15.7188 10H11.875C11.9375 9.375 12 8.6875 12 8C12 7.3125 11.9375 6.65625 11.875 6H15.7188ZM15.4062 5H11.75C11.4375 3.03125 10.8125 1.34375 10.0312 0.28125C12.4688 0.9375 14.4688 2.6875 15.4062 5ZM10.75 5H5.21875C5.40625 3.875 5.71875 2.875 6.0625 2.0625C6.40625 1.3125 6.75 0.78125 7.125 0.4375C7.46875 0.125 7.75 0 8 0C8.21875 0 8.5 0.125 8.84375 0.4375C9.21875 0.78125 9.5625 1.3125 9.90625 2.0625C10.25 2.875 10.5625 3.875 10.75 5ZM0.5625 5C1.5 2.6875 3.5 0.9375 5.9375 0.28125C5.15625 1.34375 4.53125 3.03125 4.21875 5H0.5625ZM4.09375 6C4.03125 6.65625 3.96875 7.3125 3.96875 8C3.96875 8.6875 4.03125 9.375 4.09375 10H0.25C0.0625 9.375 0 8.71875 0 8C0 7.3125 0.0625 6.65625 0.25 6H4.09375ZM6.0625 13.9688C5.71875 13.1562 5.40625 12.1562 5.21875 11H10.75C10.5625 12.1562 10.25 13.1562 9.90625 13.9688C9.5625 14.7188 9.21875 15.25 8.84375 15.5938C8.5 15.9062 8.21875 16 7.96875 16C7.75 16 7.46875 15.9062 7.125 15.5938C6.75 15.25 6.40625 14.7188 6.0625 13.9688ZM5.9375 15.75C3.5 15.0938 1.5 13.3438 0.5625 11H4.21875C4.53125 13 5.15625 14.6875 5.9375 15.75ZM10.0312 15.75C10.8125 14.6875 11.4375 13 11.75 11H15.4062C14.4688 13.3438 12.4688 15.0938 10.0312 15.75Z"
                    fill="#2D3748"
                  />
                </svg>
                <Text fontWeight={400} color="gray.600" textAlign="start" lineHeight="20px" fontSize="14px">
                  Website
                </Text>
              </ChakraLink>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
